import Loader from "components/common/loader";
import { FC, useMemo, useState } from "react";
import { useParams } from "react-router-dom";
import { FetchAnalysisLog } from "routes/administration/queries/analysis";
import { LogEntry } from "routes/analysis/types/analysis";

type ParsedLog = {
  timestamp: string;
  message: string;
  timeElapsed?: string;
  type: number;
}

const steps = [
  { label: 'Sanitizing'},
  { label: 'Processing'},
  { label: 'Analyzing'},
];

const LogViewer: FC<{ analysisId: string }> = ({ analysisId }) => {
  const { clientId } = useParams();
  const [openStep, setOpenStep] = useState<string>("");
  const { data: logData } = FetchAnalysisLog(analysisId, clientId);
  const parseLog = (logData: LogEntry[]) => {
    var result: { [key: string]: ParsedLog[] } = {};
    if (logData) {
      for (const logEntry of logData) {
        var timeElapsed = logEntry.message.match(/\[(.*?)\]/)?.[1].split(".")[0];
        var message = logEntry.message.replace(/\[.*?\]/g, "").trim();
        const key = logEntry.message.split(" ")[0].replace(":", "");
        if (!result[key])
          result[key] = [];
        result[key].push({ timestamp: logEntry.timestamp, type: logEntry.type, message: message, timeElapsed: timeElapsed ? timeElapsed.replace("]", "") : undefined });
      }
    }
    return result;
  }

  const parsedLog = useMemo(() => logData ? parseLog(logData) : {}, [logData]);

  return (
    logData
      ? <>
        <div className="list-row">
          <div
            className="flex items-center p-4 gap-4"
          >
            <div className="basis-2/4">
              <p>{`Analysis: ${analysisId}`}</p>
              <p>{`Log entries: ${logData.length}`}</p>
            </div>
            <div className="basis-2/4">
              <p>{`Warnings: ${logData.filter(entry => entry.type === 2).length}`}</p>
              <p>{`Errors: ${logData.filter(entry => entry.type === 3).length}`}</p>
            </div>
          </div>
        </div>
        {
          steps.map((step, index) => {
            const stepLog = parsedLog[step.label];
            return (
              <div key={step.label} className="list-row">
                <div
                  className="flex items-center p-4 gap-4"
                >
                  <div
                    className="basis-12">
                    <span
                      onClick={() => setOpenStep(openStep === step.label ? "" : step.label)}
                      className={openStep === step.label ? "Appkit4-icon icon-down-chevron-outline pointer" : "Appkit4-icon icon-right-chevron-outline pointer"}
                    />
                  </div>
                  <div className="basis-96">
                    <b>{step.label}</b>
                  </div>
                  <div className="basis-32">
                    <p>{stepLog?.length}</p>
                  </div>
                  <div className="basis-32">
                    <p>{stepLog?.filter(log => log.type === 3).length > 0 && <span className="Appkit4-icon icon-alert-fill access-risk"></span>}</p>
                  </div>
                </div>
                {
                  openStep === step.label && <div className="ap-accordion-open">
                    {stepLog?.map((log, idx) => (
                      <div key={idx} className="list-row-1 flex items-center p-4 gap-4">
                        <div
                          className="basis-12">
                          {log.type === 0 && <span className="Appkit4-icon icon-bug-outline ap-font-16 ap-text-secondary"></span>}
                          {log.type === 1 && <span className="Appkit4-icon icon-information-outline ap-font-16 ap-text-secondary"></span>}
                          {log.type === 2 && <span className="Appkit4-icon icon-alert-fill ap-font-16 ap-text-warning"></span>}
                          {log.type === 3 && <span className="Appkit4-icon icon-alert-fill ap-font-16 access-risk"></span>}
                            </div>
                          <div className="grow">
                            {log.message}
                          </div>
                          <div className="basis-32">
                            {log.timeElapsed}
                          </div>
                        </div>
                    ))}
                    </div>
                }
              </div>
            );
          })
        }
      </>
            : <Loader loadingType="circular" />
        );
}

export default LogViewer;